import axios from "axios";
import { clearLogoutData } from "../logout/action";
import { Branch_Contact_URL } from "../Url";

export const saveDeletBrachIdActions = {
  SAVE_DELETE_BRANCH_PERSONID_SUCCESS: "SAVE_DELETE_BRANCH_PERSONID_SUCCESS",
  SAVE_DELETE_BRANCH_PERSONID_ERROR: "SAVE_DELETE_BRANCH_PERSONID_ERROR",
};

export function saveDeletBrachIdDetails(props) {
  const { access_token, values, partnerFirmId, partnerBranchId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Branch_Contact_URL}/deletePartnerBranchByPartnerBranchIdAndPartnerFirmId?partnerBranchId=${partnerBranchId}&partnerFirmId=${partnerFirmId}&active=false`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveDeletBrachIdDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveDeletBrachIdDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveDeletBrachIdDetailsError(err));
          return err.response;
        }
      });
}

export function saveDeletBrachIdDetailsError(error) {
  return {
    type: saveDeletBrachIdActions.SAVE_DELETE_BRANCH_PERSONID_ERROR,
    payload: error,
  };
}

export function saveDeletBrachIdDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveDeletBrachIdActions.SAVE_DELETE_BRANCH_PERSONID_SUCCESS,
      payload: props,
    });
  };
}
